import { useTranslation } from '../../../i18n';
import React, { useState } from 'react';
import { Card, Tabs, Space } from 'antd';
import {
    SettingOutlined,
    FileTextOutlined,
    FileImageOutlined
} from '@ant-design/icons';
import ErrorPageManager from './ErrorPageManager';
import MimeManager from './MimeManager';

const { TabPane } = Tabs;

/**
 * 高级配置:错误页 + MIME。
 * 2026-10-22 去掉 EasyPanel 遗留:CDN 白名单(共享主机不提供 CDN)、限速/连接数(由套餐决定)、
 * SSI、模板变量、能力检测;Web 应用在独立的应用标签页里。
 */
const AdvancedSettings = ({ vhostName }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('errorpage');

    return (
        <Card
            title={
                <Space>
                    <SettingOutlined />
                    {t('Advanced configuration')}
                </Space>
            }
        >
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane
                    tab={
                        <span>
                            <FileTextOutlined />
                            {t('Error page')}
                        </span>
                    }
                    key="errorpage"
                >
                    <ErrorPageManager vhostName={vhostName} />
                </TabPane>

                <TabPane
                    tab={
                        <span>
                            <FileImageOutlined />
                            {t('MIME type')}
                        </span>
                    }
                    key="mime"
                >
                    <MimeManager vhostName={vhostName} />
                </TabPane>
            </Tabs>
        </Card>
    );
};

export default AdvancedSettings;
